module.exports = __webpack_public_path__ + "static/bot5-dca64c49e60fd92354928ab9c8b441a4.jpg";